var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Views',{attrs:{"loading":_vm.loading,"error":_vm.error}},[(_vm.nodes && _vm.nodes.rows)?_c('Table',{attrs:{"header":_vm.nodes.header,"rows":_vm.nodes.rows}}):(!_vm.loading && !_vm.error)?_c('NoData'):_vm._e(),_c('div',{staticClass:"mt-4"},[_c('AgentInstallation',{attrs:{"color":"primary"}},[_vm._v("Add nodes")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }